// ----
// Silverchair JavaScript Utility Object
// ----

// This object has functions and capabilities that may be useful to any dev.
// Usage: SCM.JSUtility.functionName();  Can be used anywhere in the application




// ----
// Globals in the Global Namespace
// ----

// Debounce function. Use this on resize to avoid taxing the browser.
var debounce = function(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

// Unlike debounce, which delays function execution until a certain time has passed without the function being called again, 
// throttle ensures a function is executed at most once in a specified time interval, regardless of how many times it's called.
var throttle = function (func, limit) {
    let inThrottle;
    return function () {
        const context = this;
        if (!inThrottle) {
            func.call(context);
            inThrottle = true;
            setTimeout(() => inThrottle = false, limit);
        }
    };
};

$.fn.is_on_screen = function () {
    var win = $(window);
    var viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();
    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();
    return !(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom);
};

// Get viewport dimensions w/o the need for Modernizr or some other dependency
function updateViewportDimensions() {
    var w=window,d=document,e=d.documentElement,g=d.getElementsByTagName('body')[0],x=w.innerWidth||e.clientWidth||g.clientWidth,y=w.innerHeight||e.clientHeight||g.clientHeight;
    return { width:x,height:y };
}

// setting the viewport width
var viewport = updateViewportDimensions();





var SCM = SCM || {};

SCM.JSUtility = (function ($) {
    // private variables and functions go here


    // All of the public facing methods and properties that are returned
    var publicApi = {
        // ----
        // equalHeights: Equalizes the height of two or more DOM Elements when above a certain breakpoint.
        // @param "items". string. css selector for dom elements to be height equalized.
        // @param "bp". number. viewport width breakpoint above which the dom elements are equalized.
        // ----
        equalHeights: function (items, bp) {
            equalize();
            $(window).resize(function () {
                equalize();
            });
            function equalize() {
                if ($(items).length && $(window).width() > bp) {
                    var height = 0,
                        $items = $(items);
                    $items.attr('style', '');
                    $items.each(function () {
                        var thisHeight = $(this).outerHeight();
                        if (height < thisHeight) {
                            height = thisHeight;
                        }
                    });
                    $(items).css('height', height);
                } else {
                    $(items).attr('style', '');
                }
            }
        },




        // ----
        // smoothScrollLinks: Causes in-document anchor links to scroll smoothly to the target.
        // @param "links". string. css selector for the <a> links (not for the destinations). It expects the anchors
        //          to have a hash (href). I.e. <a class="anchor-link" href="238765"></a>
        // @param "animLength". optional number. timing in milliseconds it takes to do the scroll. Default is 500ms.
        // ----
        //smoothScrollLinks: function (links, animLength) {
        //    var $links = $(links);

        //    $links.click(function () {
        //        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        //            var target = $(this.hash);
        //            var scrolltop = target.offset().top;
        //            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        //            if (target.length) {
        //                $('html,body').animate({
        //                    scrollTop: scrolltop
        //                }, animLength ? animLength : 500);
        //                return false;
        //            }
        //        }
        //    });
        //},





        // ----
        // addStateToggle: Toggles the state of any UI element by adding and removing active classes
        // @param "toggler": string css selector. The element that causes the target to change state
        // @param "target": string css selector. The element that's state is being toggled
        // @param "documentAware" (optional): boolean. Default: false. If true,
        //          toggles an active class on the body element.
        // ----
        addStateToggle: function(toggler, target, documentAware) {
            var $toggler = $(toggler),
                $target = $(target),
                targetActiveClass = 'active-state',
                togglerActiveClass = 'target-active',
                $body = $('body'),
                htmlActiveClass = target.replace(/.|#/, '') + '-active',
                $close = $target.find('.close');

            // Give HTML element awareness?
            documentAware = documentAware || false;

            function resetState() {
                $target.removeClass(targetActiveClass);
                $toggler.removeClass(togglerActiveClass);

                if (documentAware) {
                    $body .removeClass(htmlActiveClass);
                }
            }

            $toggler.click(function(e) {
                // toggle anchors shouldn't use normal browser anchor behavior
                e.preventDefault();

                $target.toggleClass(targetActiveClass);
                $toggler.toggleClass(togglerActiveClass);

                if (documentAware) {
                    $body.toggleClass(htmlActiveClass);
                }
            });

            // If user clicks outside of either the toggler or the target, remove active state
            $body.click(function(e) {
                if (!$(e.target).closest($toggler.add($target)).length) {
                    resetState();
                }
            });

            // Close Button
            $close.click(function() {
                resetState();
            });
        },





        // ----
        // toggleVisibility: Binds a click event to a toggler that jQuery fadeToggles a target and adds/removes active classes
        //                   on both the toggler and the target..
        // @param "toggler": string css selector. The element that causes the target toggle visibility.
        // @param "mobileOnly" (optional): boolean. Only attaches event for mobile.
        // @param "bp" (optional): number. upper breakpoint for mobile. Defaults to 640px if no breakpoint provided.
        // @var "$target": grabs the target from the "data-toggle-target" attribute from the toggler.
        //                 Assumes a class and not an ID.
        // ----
        toggleVisibility: function(toggler, mobileOnly, bp) {
            var $toggler = $(toggler),
                togglerActiveClass = 'target-active',
                targetActiveClass = 'active';

            // defaults to false unless something is passed in.
            mobileOnly = mobileOnly || false;
            // defaults to 640px unless something is passed in.
            bp = bp || 640;

            var clickHandler = function() {
                var $this = $(this),
                    $target = $('.' + $this.attr('data-toggle-target'));

                $this.toggleClass(togglerActiveClass);
                $target.slideToggle().toggleClass(targetActiveClass);
            };

            var manageClickEvents = debounce(function() {
                if (mobileOnly) {
                    viewport = updateViewportDimensions();

                    if (viewport.width > bp) {
                        // remove click events and inline styles added by jQuery fadeToggle()
                        $toggler.off('click.toggle-visibility');
                        $toggler.removeClass(togglerActiveClass);
                        $toggler.each(function() {
                            var $target = $('.' + $(this).attr('data-toggle-target'));
                            $target.removeAttr('style').removeClass(targetActiveClass);
                        });
                    } else {
                        // add click event back in. off event exists so click event isn't bounded more than once.
                        $toggler.off('click.toggle-visibility');
                        $toggler.on('click.toggle-visibility', clickHandler);
                    }
                } else {
                    // do the fadeToggle regardless of viewport size
                    $toggler.on('click.toggle-visibility', clickHandler);
                }
            }, 150, true);

            // run once
            manageClickEvents();

            if (mobileOnly) {
                $(window).resize(function() {
                    manageClickEvents();
                });
            }
        },

        getSearchParamByName: function (key) {
            return new URLSearchParams(window.location.search).get(key);
        },

        // In some weird cases, we slap a #hash onto the back of a return URL, but it's formatted like a search parameter
        // e.g. [domain]/[journalName]/issue#triggerAlertType=3
        // This method feeds the hash value (minus the leading '#') into a URLSearchParams object so we can pretend it's a search param
        getParamFromHash: function (key) {
            return new URLSearchParams(window.location.hash.substring(1)).get(key);
        },

        // When we're done with the aforementioned hash-disguised-as-a-search-param
        // We want to kill it and destroy the evidence
        removeParamFromHash: function (hashKey) {
            let hashValue = SCM.JSUtility.getParamFromHash(hashKey);

            if (hashValue) {
                window.location.replace(window.location.hash.replace(`${hashKey}=${encodeURI(hashValue)}`, ''));
            }
        }
    };

    return publicApi;

})(jQuery);